import TileArticle from './TileArticle'

export default TileArticle
// eslint-disable-next-line import/export
export * from './TileArticle'
